import { createApp } from 'vue';
import LocationsOverview from '../vue/LocationsOverview.js';

const CONTACT_API_URL = '/umbraco/api/contact/getcontactdata';

// Cache the fetch promise per (employeesNodeId, culture) so multiple components
// on one page share a single request.
const dataPromiseCache = {};

function fetchContactData(employeesNodeId, culture) {
    const key = employeesNodeId + '|' + culture;
    if (!dataPromiseCache[key]) {
        const params = new URLSearchParams({
            employeesNodeId: employeesNodeId || 0,
            cultureCode: culture || 'da-DK'
        });
        dataPromiseCache[key] = fetch(CONTACT_API_URL + '?' + params, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json; charset=utf-8' }
        }).then(response => response.json());
    }
    return dataPromiseCache[key];
}

export function locationsOverview() {
    const mounts = document.querySelectorAll('.locations-overview__app');
    mounts.forEach(el => {
        const config = {
            employeesNodeId: parseInt(el.dataset.employeesNodeId) || 0,
            prefilterLocation: parseInt(el.dataset.prefilterLocation) || 0,
            prefilterDepartment: parseInt(el.dataset.prefilterDepartment) || 0,
            hideFilters: el.dataset.hideFilters === 'true',
            culture: el.dataset.culture || 'da-DK'
        };

        fetchContactData(config.employeesNodeId, config.culture)
            .then(data => {
                createApp(LocationsOverview, { config: config, data: data }).mount(el);
            })
            .catch(err => {
                console.error('Failed to load contact data', err);
            });
    });
}
